import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isLoading } from "../../redux/loader";
import { ClientContract } from "../../redux/auth/types";
import { getSalesAgreement } from "../../redux/auth/saga";
import CustomModal from "../../components/Modal/modal";
import { Loader } from "../../components";

const AgreementModal = ({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (pen: boolean) => void;
}) => {
  const dispatch = useDispatch();
  const loading = useSelector(isLoading);
  const [agreement, setAgreement] = useState<ClientContract>();
  useEffect(() => {
    open &&
      dispatch(
        getSalesAgreement({
          payload: {
            onSuccess: (p, r) => {
              r != null && r.length > 0 && setAgreement(r[0]);
            },
            onError: () => {},
          },
        })
      );
  }, [dispatch, open]);
  return (
    <React.Fragment>
      <CustomModal
        outsideClick
        onHide={() => setOpen(false)}
        open={open}
        title={agreement ? agreement.Title : ""}
      >
        {loading && <Loader />}
        {agreement && (
          <p
            dangerouslySetInnerHTML={{
              __html: agreement.Description,
            }}
          />
        )}
      </CustomModal>
    </React.Fragment>
  );
};
export default AgreementModal;
